module.exports = __webpack_public_path__ + "static/img/login-bg.e2134055.e2134055.jpg";